import { Injectable, Inject  } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclDatatableResizeService {

  constructor() {

  }

  initResize(excludeResizeCol) {

    let ths = (document.querySelectorAll('.dataTable th') as any);
    let tbl = (document.querySelector('.dataTable') as any );

    let startOffset = 0;
    let nextOffset = 0;
    let totWidth = 0;
    let currWidth = 0;
    let nextWidth = 0;
    let thElm;
    const padding = 56;
    let mDown = 0;
    let mDrag = 0;
    let minWidth = 20;


    for (let i = 0; i < ths.length; i++) {
      let th = ths[i];
      let tempSpan = document.createElement('span');
      tempSpan.style.height = '100%';
      tempSpan.style.width = '9px';
      tempSpan.style.padding = '22px 0';
      tempSpan.style.position = 'absolute';
      tempSpan.style.right = '-5px';
      tempSpan.style.top = '-6px';

      tempSpan.style.zIndex = '9999';
      th.appendChild(tempSpan);

      if (excludeResizeCol.indexOf(i) === -1) {
        tempSpan.style.cursor = 'col-resize';
        tempSpan.addEventListener('mousedown',  (e) => {
          tbl.addClass('sc-dt-mousedown');

          thElm = th;
          const thElmNexSibling = this.nextDisplaySibling(thElm);
          totWidth = parseFloat(thElm.style.width) + parseFloat(thElmNexSibling.style.width);
          th.classList.add('disable');
          startOffset = Number(window.getComputedStyle(th, null).getPropertyValue('width')) - e.pageX;
          const nextSiblingTh = this.nextDisplaySibling(th);
          nextOffset = Number(window.getComputedStyle(nextSiblingTh, null).getPropertyValue('width')) + e.pageX;
          mDown = e.pageX;


          pauseEvent(e);
        });
      } else {
        tempSpan.style.cursor = 'pointer';
      }

    }


    document.addEventListener('mousemove',  (e) => {
      if (thElm) {
        pauseEvent(e);
        const thElmNexSibling = this.nextDisplaySibling(thElm);
        if (nextOffset - e.pageX > 0 && startOffset + e.pageX > 0 && Math.abs(mDown - e.pageX) >= 1 ){
          currWidth = (startOffset + e.pageX);
          // nextWidth = (nextOffset - e.pageX);
          nextWidth = totWidth - currWidth;
          if (currWidth < minWidth) {
            currWidth = minWidth;
            nextWidth = (totWidth - minWidth);
          } else if (nextWidth < minWidth) {
            currWidth = (totWidth - minWidth);
            nextWidth = minWidth;
          }


          thElm.style.width = currWidth  + 'px';
          thElmNexSibling.style.width = nextWidth + 'px';
        }
      }

    });

    const pauseEvent = (e) => {
      if (e.stopPropagation) { e.stopPropagation(); }
      if (e.preventDefault) { e.preventDefault(); }
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    };

    document.addEventListener('mouseup',  (e) => {
      if (thElm) {
        thElm.classList.remove('disable');
      }
      if (currWidth < minWidth) {
        currWidth = minWidth;
        nextWidth = (totWidth - minWidth);
      } else if (nextWidth < minWidth) {
        currWidth = (totWidth - minWidth);
        nextWidth = minWidth;
      }

      if (thElm) {
        thElm.style.width = currWidth + 'px';
        thElm.nextSibling.style.width = nextWidth + 'px';
      }

      thElm = undefined;
      mDown = 0;
      tbl.classList.remove('sc-dt-mousedown');
    });

  }

  nextDisplaySibling(elem) {
    let ns = elem.nextSibling;

    while (ns) {
      if (window.getComputedStyle(ns, null).getPropertyValue('display') !== 'none') {
        break;
      }
      ns = ns.nextSibling;
    }

    return ns;
  }

  calculateWidth(fieldName) {
    const componentElement = (document.getElementById(fieldName) as HTMLTableElement);
    if (componentElement && componentElement.rows && componentElement.rows[1] && componentElement.rows[1]) {
      const ths = (document.getElementById(fieldName)  as HTMLTableElement).rows[0].children;
      for (let i = 0; i < ths.length; i++) {
        const th = (ths[i] as HTMLTableElement);
        th.style.width = (Number(window.getComputedStyle(th, null).getPropertyValue('width')) + 1) + 'px';
      }
    }
  }
}
